import React from 'react';
import { Box } from '@mui/material';
import { exchangeSpecificStringifiedNumber } from '../../../services/exchanges';
import { formatPriceWithPrecision } from '../../../utils/utilfunction';

const formatTimestampToTime = (timestamp) => {
  if (!timestamp) return 'Invalid Time';
  const date = new Date(timestamp * 1000);
  return `${date.getHours().toString().padStart(2, '0')}:${date
    .getMinutes()
    .toString()
    .padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
};

const MarketDepthContent = ({ instrument }) => {
  const formatValue = (value) => {
    if (!value) return '-';
    
    // Apply price precision formatting for CDS and DCSX exchanges with trailing zeros
    if ((instrument.exchange === 'CDS' || instrument.exchange === 'DCSX') && instrument.price_precision !== undefined) {
      return formatPriceWithPrecision(value, instrument.price_precision, {
        showCurrency: false,
        showCommas: false,
        removeTrailingZeros: false
      });
    }
    
    return exchangeSpecificStringifiedNumber(instrument.exchange, value);
  };

  return (
    <Box sx={{ width: '100%', fontSize: '0.75rem' }}>
      {/* Hide OHLC and Volume for CDS and DCSX exchanges */}
      {instrument.exchange !== 'CDS' && instrument.exchange !== 'DCSX' && (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: 1,
            p: 1,
            backgroundColor: "action.hover",
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <Box>
            <Box sx={{ color: "text.secondary" }}>Open</Box>
            <Box>{formatValue(instrument.openPrice)}</Box>
          </Box>
          <Box>
            <Box sx={{ color: "text.secondary" }}>High</Box>
            <Box>{formatValue(instrument.highPrice)}</Box>
          </Box>
          <Box>
            <Box sx={{ color: "text.secondary" }}>Low</Box>
            <Box>{formatValue(instrument.lowPrice)}</Box>
          </Box>
          <Box>
            <Box sx={{ color: "text.secondary" }}>Close</Box>
            <Box>{formatValue(instrument.closePrice)}</Box>
          </Box>
          <Box>
            <Box sx={{ color: "text.secondary" }}>Volume</Box>
            <Box>{instrument.volume || '-'}</Box>
          </Box>
        </Box>
      )}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(5, 1fr)",
          gap: 1,
          p: 1,
          backgroundColor: "action.hover",
          fontSize: '0.75rem'
        }}
      >
        <Box>
          <Box sx={{ color: "text.secondary" }}>Best bid</Box>
          <Box>{formatValue(instrument.bestBidPrice)}</Box>
        </Box>
        <Box>
          <Box sx={{ color: "text.secondary" }}>Bid Qty</Box>
          <Box>{instrument.bestBidQuantity || '-'}</Box>
        </Box>
        <Box>
          <Box sx={{ color: "text.secondary" }}>Best ask</Box>
          <Box>{formatValue(instrument.bestAskPrice)}</Box>
        </Box>
        <Box>
          <Box sx={{ color: "text.secondary" }}>Ask Qty</Box>
          <Box>{instrument.bestAskQuantity || '-'}</Box>
        </Box>
        <Box>
          <Box sx={{ color: "text.secondary" }}>LTT</Box>
          <Box>{formatTimestampToTime(instrument.ltt)}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MarketDepthContent; 